import '~client/settings/axios';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';
import { MuiProviders } from 'common/mui/mui-providers';
import { ApolloClientProvider } from 'common/apollo/index';
import i18n from '~client/settings/i18n';
import store from '~client/store';
import Auth from '~pages/auth';
import Dashboard from '~pages/dashboard';
import Comments from '~pages/comments';
import HelpCenter from '~pages/help-center';
import Udesk from '~pages/udesk';
import ArticleDesign from '~pages/design';
import './antd.less';
import './index.scss';
import { cookieNames } from '~constants/storage';
import cookies from 'js-cookie';
import { initSentry } from 'common/utils/sentry';
import { systemName } from 'common/constants/system';

initSentry(systemName.cms);

export const isAuthorized = state =>
  state.token ? <Redirect to="/properties" /> : <Redirect to="/login" />;

export const Routes = () => {
  cookies.set(cookieNames.systemName, systemName.cms, { path: '/' });
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Suspense fallback="">
        <div style={{ height: '100%' }}>
          <Switch>
            <Route path="/" exact render={() => isAuthorized(store.getState().auth?.toJS())} />
            <Route path="/login" component={Auth} />
            <Route path="/forgot-password/:email?" component={Auth} />
            <Route path="/set-password" component={Auth} />
            <Route path="/article-design/:type/:index/:id?" component={ArticleDesign} />
            <For
              each="path"
              of={[
                '/properties',
                '/property',
                '/landlords',
                '/payment',
                '/booking',
                '/landlord',
                '/pms-integrations',
                '/students',
                '/locations/countries',
                '/locations/cities',
                '/locations/universities',
                '/locations/city',
                '/locations/area',
                '/locations/university',
                '/account',
                '/account/my-profile',
                '/contract',
                '/bookings',
                '/billing',
                '/strategy',
                '/reconciliation',
                '/referral',
                '/agent',
                '/content/dashboard-release',
                '/content/article',
                '/marketing/tags',
                '/marketing/special-offers',
                '/marketing/reviews',
                '/marketing/notification',
              ]}
            >
              <Route key={path} path={path} component={Dashboard} />
            </For>
            <Route path="/comments/:propertySlug" component={Comments} />
            <Route path="/udesk" component={Udesk} />
            <Route path="/help-center" component={HelpCenter} />
            <Redirect to="/login" />
          </Switch>
        </div>
      </Suspense>
    </BrowserRouter>
  );
};

const App = () => (
  <MuiProviders>
    <Provider store={store}>
      <ConfigProvider locale={enUS}>
        <I18nextProvider i18n={i18n}>
          <ApolloClientProvider>
            <Routes />
          </ApolloClientProvider>
        </I18nextProvider>
      </ConfigProvider>
    </Provider>
  </MuiProviders>
);

ReactDOM.render(<App />, document.getElementById('root'));
